import React from 'react';
import PropTypes from 'prop-types';

import { MeanInfoItem } from './mean-info-item';

export const MeanInfo = (props) => {
  const { direction, from, to } = props;

  if (direction === 'from') {
    return <MeanInfoItem reverse data={from.data} />;
  }
  if (direction === 'to') {
    return <MeanInfoItem data={to.data} />;
  }
  return null; // meanType && meanNumber ? `${meanType} ${meanNumber}` : null;
};

MeanInfo.propTypes = {
  direction: PropTypes.any.isRequired,
  from: PropTypes.any.isRequired,
  to: PropTypes.any.isRequired,
};
